import { render } from "./OwnersPage.vue?vue&type=template&id=6b9892fd&scoped=true"
import script from "./OwnersPage.vue?vue&type=script&lang=js"
export * from "./OwnersPage.vue?vue&type=script&lang=js"

import "./OwnersPage.vue?vue&type=style&index=0&id=6b9892fd&scoped=true&lang=css"
import "./OwnersPage.vue?vue&type=style&index=1&id=6b9892fd&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9892fd"]])

export default __exports__